import { createPortal } from 'react-dom';
import { webPortalTarget } from '../../platforms/web/desktop/webPortalTarget';

export type AiSnapWikiInfo = {
  introduction?: string;
  flavor?: string;
  health_notes?: string;
  serving_tips?: string;
};

type Props = {
  open: boolean;
  title: string;
  loading?: boolean;
  info: AiSnapWikiInfo | null;
  onClose: () => void;
};

export function AiSnapWikiSheet(props: Props) {
  if (!props.open) return null;

  const sections = [
    { key: 'introduction', icon: '📋', label: '简介' },
    { key: 'flavor', icon: '🌿', label: '风味' },
    { key: 'health_notes', icon: '⚠️', label: '健康注意' },
    { key: 'serving_tips', icon: '🍶', label: '建议' },
  ] as const;

  const node = (
    <div className="as-overlay" onClick={(e) => e.target === e.currentTarget && props.onClose()}>
      <div className="as-sheet as-editor">
        <div className="as-handle" />
        <div className="as-top">
          <button className="as-icon-btn" onClick={props.onClose} aria-label="返回">←</button>
          <div className="as-title">百科：{props.title}</div>
          <div style={{ width: 36 }} />
        </div>

        <div className="as-content">
          {props.loading ? (
            <div className="as-tip">正在查询百科信息…</div>
          ) : props.info ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {sections.map((s) => {
                const text = String((props.info as any)[s.key] || '').trim();
                if (!text) return null;
                return (
                  <div key={s.key} className="as-card">
                    <div className="as-card-title">{s.icon} {s.label}</div>
                    <div className="as-tip" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, fontSize: 13, color: 'var(--web-snap-copy, rgba(226,232,240,0.9))' }}>{text}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="as-tip">暂无百科信息</div>
          )}
        </div>
      </div>
    </div>
  );

  return typeof document !== 'undefined' ? createPortal(node, webPortalTarget()) : node;
}
